import React from 'react';

const FormSkeleton: React.FC = () => {
  return (
    <div className="p-6 rounded space-y-6 animate-pulseFade">
      <div className="h-8 w-1/3 bg-gray-200 dark:bg-gray-700 rounded" />  
      <div className="space-y-4">
        <div className="h-4 w-1/4 bg-gray-200 dark:bg-gray-700 rounded mb-2" />  
        <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />  
        <div className="h-4 w-1/4 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
        <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="h-4 w-1/4 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
        <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="space-y-4">
          <div className="h-4 w-1/3 bg-gray-200 dark:bg-gray-700 rounded mb-2" />  
          <div className="border border-gray-300 dark:border-gray-600 p-4 rounded-md space-y-4">
            <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />  
            <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />  
          </div>
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
        <div className="mt-6 flex justify-end gap-4">
          <div className="h-10 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-10 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
      </div>
    </div>
  );
};

export default FormSkeleton;